/* eslint-disable react-hooks/exhaustive-deps */
import InputForm from "../../../components/inputs/InputForm";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Col, InputGroup, Row, Form as FormI } from "react-bootstrap";
import { Loader, toaster } from "rsuite";
import { useEffect, useState } from "react";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { generatePassword } from "../../../libs/formats";
import { Usuario, UsuarioForm } from "../../../types/admin-usuarios/Usuario";
import { InputGroupNumber } from "../../../components/inputs/InputGroupNumber";
import InputSearch from "../../../components/inputs/InputSelectSearch";

const defaultForm: UsuarioForm = {
  fullname: "",
  email: "",
  system: "",
  phone: "",
  pwd: "",
};

export default function Form({
  setOpen,
  selected,
}: {
  setOpen: any;
  selected?: Usuario;
}) {
  const [loading, setLoading] = useState<boolean>(false);
  const [sistemas, setSistemas] = useState<Array<any>>([]);

  const formSchema = Yup.object().shape({
    fullname: Yup.string().required("Ingrese el nombre del agente"),
    email: Yup.string()
      .required("Ingrese un correo electrónico")
      .email("Correo electrónico invalido"),
    phone: Yup.string().required("Ingrese un número telefónico"),
    system: Yup.string().required("Seleccione un sistema"),
    pwd: selected
      ? Yup.string().min(6, "La longitud minima es 6 caracteres")
      : Yup.string()
          .required("Ingrese una contraseña")
          .min(6, "La longitud minima es 6 caracteres"),
  });

  const {
    handleSubmit,
    handleReset,
    handleBlur,
    setFieldValue,
    setValues,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: defaultForm,
    validationSchema: formSchema,
    onSubmit: (values) => {
      swalAction(
        save,
        `${selected ? "Editar" : "Guardar"} Usuario`,
        `¿Desea ${selected ? "editar" : "guardar"} este usuario?`,
        "question"
      );
    },
    onReset: () => {
      setOpen(false);
    },
  });

  function onChange({ target }: { target: any }) {
    setFieldValue(target.name, target.value);
  }

  async function getSistemas() {
    const res = await peticionBack({}, "/sistemas", "GET", false, toaster);
    if (res) setSistemas([...res.data]);
  }

  useEffect(() => {
    getSistemas();
    if (selected)
      setValues(
        {
          fullname: selected.fullname,
          email: selected.email,
          phone: selected.phone,
          system: selected.system._id || "",
        },
        true
      );
  }, []);

  async function save() {
    const method = selected ? "PUT" : "POST";
    const rute = selected ? `/${selected._id}` : "";
    setLoading(true);

    const params = {
      fullname: values.fullname,
      email: values.email,
      phone: `+52${values.phone.toString()}`,
      pwd: values.pwd,
      system: values.system,
    };
    const res = await peticionBack(
      params,
      `/usuarios` + rute,
      method,
      true,
      toaster
    );
    if (res) {
      if (selected && values.pwd) {
        const params = {
          pwd: values.pwd,
        };
        const resPwd = await peticionBack(
          params,
          `/usuarios/changePassword` + rute,
          method,
          true,
          toaster
        );
        if (resPwd) handleReset(null);
      } else handleReset(null);
    }
    setLoading(false);
  }

  return (
    <form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col xs={12} md={6}>
          <InputForm
            label="Nombre completo"
            name="fullname"
            type="text"
            value={values.fullname}
            touched={touched.fullname}
            error={errors.fullname}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
          />
        </Col>
        <Col xs={12} md={6}>
          <InputForm
            label="Correo electónico"
            name="email"
            type="text"
            value={values.email}
            touched={touched.email}
            error={errors.email}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
          />
        </Col>
        <Col xs={12} md={6}>
          <InputGroupNumber
            label="Teléfono"
            name="phone"
            value={values.phone}
            touched={touched.phone}
            error={errors.phone}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            disableSep
            maxLength={10}
            required
            left={"+52"}
          />
        </Col>

        <Col xs={12} md={6}>
          <LocalPassword
            label="pwd"
            name="pwd"
            value={values.pwd}
            touched={touched.pwd}
            error={errors.pwd}
            // onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            onChange={onChange}
            required={!selected}
          />
        </Col>

        <Col xs={12} md={6}>
          <InputSearch
            label="Sistema"
            name="system"
            value={values.system as string}
            touched={touched.system}
            error={errors.system}
            values={sistemas}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
          />
        </Col>
      </Row>
      <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2">
        <Button variant="danger" type="reset">
          Cancelar
        </Button>
        <Button variant="success" type="submit">
          Guardar
        </Button>
      </div>

      {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
    </form>
  );
}
function LocalPassword(props: any) {
  const [showText, setShowText] = useState(false);

  function generate() {
    const pass = generatePassword();
    props.onChange({ target: { name: "pwd", value: pass } });
  }

  return (
    <FormI.Group className="mb-3 position-relative">
      <FormI.Label>
        Contraseña <span className="text-danger">*</span>
      </FormI.Label>
      <InputGroup>
        <Button variant="outline-secondary" onClick={() => generate()}>
          <FontAwesomeIcon
            icon={faKey}
            style={{ minWidth: "15px", maxWidth: "15px" }}
          />
        </Button>
        <FormI.Control
          type={showText ? "text" : "pwd"}
          name={props.name}
          value={props.value}
          onBlur={props.handleBlur}
          onChange={props.onChange}
          isInvalid={!!props.error && props.touched}
          onCopy={(e) => e.preventDefault()}
        />
        <Button
          variant="outline-info rounded-end"
          onClick={() => setShowText(!showText)}
        >
          <FontAwesomeIcon
            icon={showText ? faEyeSlash : faEye}
            style={{ minWidth: "15px", maxWidth: "15px" }}
          />
        </Button>
        <FormI.Control.Feedback type="invalid">
          {props.error}
        </FormI.Control.Feedback>
      </InputGroup>
    </FormI.Group>
  );
}
/*
interface AgenteUsuario extends Usuario {
  pwd: string;
}
*/
